import { FarmConverterRule, MapControlLegendType } from 'src/app/domainObjects/transformers/farmConverterTransform';
import { TransformRuleViewModel } from 'src/app/viewModels/transformRuleViewModel';
import { __values } from 'tslib';

export class FarmConverterRuleViewModel {
    mapIndex: number;
    mapInclude: boolean;	
    mapFrom: string;	
    mapType: MapControlLegendType;	
    mapTo: string;	
    mapShow: boolean;
    isDefault: boolean;
    constructor(rule: FarmConverterRule) {
      this.mapIndex = rule.mapIndex;
      this.mapInclude = rule.mapInclude;
      this.mapFrom = rule.mapFrom;
      this.mapType = rule.mapType;
      this.mapTo = rule.mapTo;
      this.mapShow = rule.mapShow;
      this.isDefault = rule.isDefault;
    }

    toRule(): FarmConverterRule {
      const rule = new FarmConverterRule();
      rule.mapIndex = this.mapIndex;
      rule.mapFrom = this.mapFrom;
      rule.mapTo = this.mapTo;
      rule.mapType = this.mapType;
      rule.mapInclude = this.mapInclude;
      rule.mapShow = this.mapShow;
      
      rule.isDefault = this.isDefault;
      return rule;
    }
}
